import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { t } from "i18next";
import moment from "moment";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: TableAction.CREATE,
      label: "create",
      allowed: true,
      show: true,
      action: null,
      icon: icon({ name: "plus", style: "solid" }),
    },
    {
      name: TableAction.REFRESH,
      label: "refresh",
      allowed: true,
      show: true,
      action: null,
      icon: icon({ name: "refresh", style: "solid" }),
    },
  ],
  rowActions: [
    {
      name: RowAction.EDIT,
      label: "edit",
      icon: icon({ name: "pencil", style: "solid" }),
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("edit", element);
      },
    },
    {
      name: RowAction.DELETE,
      label: "delete",
      icon: icon({ name: "trash", style: "solid" }),
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("delete", element);
      },
    },
  ],
  rowConfiguration: {
    class: (element: any) => {
      // Si estado igual a 1 y date es menor que la fecha actual
      let now = moment();
      let date = moment(element.date);
      if ((element.status == 1 || element.status == 0) && now.isAfter(date)) { // Pendiente de jugar o jugado y fecha menor a la actual
        return 'table-danger'
      } else if (element.status == 2) { // Pendiente de revisión
        return 'table-warning'
      } else if (element.status == 3) { // Validado
        return 'table-success'
      }
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      allowOrder: true,
    },
    {
      name: "code",
      label: t("code"),
      key: "code",
      type: "string",
      show: true,
      allowOrder: false,
    },
    {
      name: "first_player_id",
      label: t("first_player_id"),
      key: "first_player.alias",
      type: "string",
      show: true,
      allowOrder: false,
    },
    {
      name: "second_player_id",
      label: t("second_player_id"),
      key: "second_player.alias",
      type: "string",
      show: true,
      allowOrder: false,
    },
    {
      name: "first_player_score",
      label: t("first_player_score_column"),
      key: "first_player_score",
      type: "string",
      show: true,
      allowOrder: false,
    },
    {
      name: "second_player_score",
      label: t("second_player_score_column"),
      key: "second_player_score",
      type: "string",
      show: true,
      allowOrder: false,
    },
    {
      name: "date",
      label: t("date"),
      key: "date",
      type: "date",
      show: true,
      allowOrder: false,
    },
    {
      name: "time",
      label: t("time"),
      key: "time",
      type: "time",
      show: true,
      allowOrder: false,
    },
    {
      name: "status",
      label: t("status"),
      key: "status",
      type: "translation",
      translation_prefix: "game_status",
      show: true,
      allowOrder: false,
    }
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const {
    getFunction,
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
  } = functions;
  tableConfig.actions[0].action = () => initializeFunction();
  tableConfig.actions[1].action = () => indexFunction();
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any) => getFunction(id);
  tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
  return tableConfig;
};
export default getConfig;
